/** @jsx jsx */
import { jsx, Box, Container, Button } from "theme-ui";
import SectionHeading from "components/section-heading";
import illustration from "assets/images/subscribe-bg.png";

const SubscribeUs = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = "mailto:service.queries@icleen.com";
  };

  return (
    <Box
      as="section"
      sx={styles.section}
      id="Contact-us"
      variant="section.subscribe"
    >
      <Container>
        <Box sx={styles.contentWrapper}>
          <SectionHeading
            // sx={styles.heading}
            title="Interested in our services and prices? Get in touch!"
            description="We have more than 30 million smart bins deployed in Europe and in the US, providing critical sanitation data and saving hundreds of thousands of dollars everyday!"
          />
          <div style={{ width: "100%", textAlign: "center" }}>
            <Button variant="secondary" onClick={handleSubmit}>
              Contact us
            </Button>
          </div>
        </Box>
      </Container>
    </Box>
  );
};

export default SubscribeUs;

const styles = {
  section: {
    background: [
      "none",
      null,
      null,
      `#F8F0EA url(${illustration}) no-repeat center bottom / contain`,
    ],
    pt: [8, null, null, null, 10],
    pb: [8, null, null, 9, 11],
  },
  contentWrapper: {
    backgroundColor: "#fff",
    borderRadius: 15,
    p: [null, null, null, "40px 110px 50px", "50px 50px", "40px"],
    gap: "50px",
    alignItems: "center",
  },
  heading: {
    textAlign: ["center", null, "left", "center", "left"],
    mb: ["30px", null, null, null, 0],
    ml: 0,
    h2: {
      fontSize: [6, null, null, null, null, 8, 9],
    },
    p: {
      lineHeight: 1.87,
      marginTop: 1,
      ml: ["auto", null, null, null, 0],
      mr: ["auto", null, null, null, 0],
      maxWidth: 420,
    },
  },
  subscribe: {
    button: {
      minHeight: ["50px", "50px", "60px"],
      fontSize: ["14px", "14px", "16px"],
      mt: ["15px", null, null, 0],
    },
  },
};
